import React from "react";
import styled from "styled-components";
import useWindowDimensions from "../constatns/size";
import electricalCompany from "../assets/images/elctrical-Company.png"
import sportsBasement from "../assets/images/Sports-Basement.png"
import masterScience from "../assets/images/master-of-science.png"
import sealedAir from "../assets/images/sealed air.png"
import { Bounce } from "react-reveal";

import "../styles/home.css";
import PartnersCard from "../components/PartnersCard";
import GrTitle, { Title } from "../components/BgTitle";

function Reference() {
    const { width, height } = useWindowDimensions();
  return (
      <div id="reference">
          <GrTitle bgTitle={"CUSTOMER REFERENCES"} 
        //   grTitleStyle={{fontSize: width * 0.05}}
           />
        <Title title={"REFERENCE"} 
        // mainTitleStyle={{fontSize: width * 0.02, marginTop: -height * 0.075}} 
        /> 
        <Container width={width} height={height} >
            <InnerContainer>
                <Bounce>
                    <PartnersCard image={electricalCompany} logoStyle={{width: 90, height: 90}}/>
                </Bounce>
                <Bounce>
                    <PartnersCard
                        image={sportsBasement}
                        logoStyle={{width: "auto", height: 150}}
                    />
                </Bounce>
                <Bounce>
                    <PartnersCard
                        image={masterScience}
                        logoStyle={{width: "auto", height: 120}}


                    />
                </Bounce>
                <Bounce>
                    <PartnersCard
                        image={sealedAir}
                        logoStyle={{width: "auto", height: 30}}

                    />
                </Bounce>
            </InnerContainer>
        </Container>
    </div>
  );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    margin-top: 50px ;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;

    
`

const InnerContainer = styled.div`
    display: flex;
    margin-top: ${({height})=> height * 0.05}px ;
    @media (max-width: 768px) {
        display: block;
    }
    

`

export default Reference;
